/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Debt_OldestInputs */

const vi_report_debt_oldest = /** @type {(inputs: Report_Debt_OldestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày cũ nhất`)
};

/**

* @param {Report_Debt_OldestInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_debt_oldest = /** @type {((inputs?: Report_Debt_OldestInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Debt_OldestInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_debt_oldest(inputs)
});